export const transformId = (id: string | undefined) => {
  return id ? id.replaceAll("-", "").toUpperCase() : "";
};
